module.exports = __webpack_public_path__ + "static/img/7.c0eff21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/7.png
// module id = UIHR
// module chunks = 0